
        var result = require("!!../../js/node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/cjs.js!../../js/node_modules/.pnpm/sass-loader@8.0.2_43442d764470988920dfed6f04cbd9ac/node_modules/sass-loader/dist/cjs.js!./main.sass");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    